/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var constants = require('../constants');

var jsonld = require('jsonld');

var ProofPurpose = require('./ProofPurpose');

module.exports = /*#__PURE__*/function (_ProofPurpose) {
  _inherits(ControllerProofPurpose, _ProofPurpose);

  /**
   * Creates a proof purpose that will validate whether or not the verification
   * method in a proof was authorized by its declared controller for the
   * proof's purpose.
   *
   * @param term {string} the `proofPurpose` term, as defined in the
   *    SECURITY_CONTEXT_URL `@context` or a URI if not defined in such.
   * @param [controller] {object} the description of the controller, if it
   *   is not to be dereferenced via a `documentLoader`.
   * @param [date] {string or Date or integer} the expected date for
   *   the creation of the proof.
   * @param [maxTimestampDelta] {integer} a maximum number of seconds that
   *   the date on the signature can deviate from, defaults to `Infinity`.
   */
  function ControllerProofPurpose() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        term = _ref.term,
        controller = _ref.controller,
        date = _ref.date,
        _ref$maxTimestampDelt = _ref.maxTimestampDelta,
        maxTimestampDelta = _ref$maxTimestampDelt === void 0 ? Infinity : _ref$maxTimestampDelt;

    _classCallCheck(this, ControllerProofPurpose);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ControllerProofPurpose).call(this, {
      term: term,
      date: date,
      maxTimestampDelta: maxTimestampDelta
    }));

    if (controller !== undefined) {
      if (typeof controller !== 'object') {
        throw new TypeError('"controller" must be an object.');
      }

      _this.controller = controller;
    }

    return _this;
  }
  /**
   * Validates the purpose of a proof. This method is called during
   * proof verification, after the proof value has been checked against the
   * given verification method (e.g. in the case of a digital signature, the
   * signature has been cryptographically verified against the public key).
   *
   * @param proof
   * @param verificationMethod
   * @param documentLoader
   * @param expansionMap
   *
   * @throws {Error} If verification method not authorized by controller
   * @throws {Error} If proof's created timestamp is out of range
   *
   * @returns {Promise<{valid: boolean, error: Error}>}
   */


  _createClass(ControllerProofPurpose, [{
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proof, _ref2) {
        var verificationMethod, documentLoader, expansionMap, result, verificationId, controller, owner, controllerId, _yield$jsonld$frame, _yield$jsonld$frame$, _yield$jsonld$frame$$, framed, verificationMethods;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verificationMethod = _ref2.verificationMethod, documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap;
                _context.prev = 1;
                _context.next = 4;
                return _get(_getPrototypeOf(ControllerProofPurpose.prototype), "validate", this).call(this, proof, {
                  verificationMethod: verificationMethod,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 4:
                result = _context.sent;

                if (result.valid) {
                  _context.next = 7;
                  break;
                }

                throw result.error;

              case 7:
                verificationId = verificationMethod.id; // if no `controller` specified, use verification method's

                if (!this.controller) {
                  _context.next = 12;
                  break;
                }

                result.controller = this.controller;
                _context.next = 42;
                break;

              case 12:
                // support legacy `owner` property
                controller = verificationMethod.controller, owner = verificationMethod.owner;

                if (!controller) {
                  _context.next = 25;
                  break;
                }

                if (!(typeof controller === 'object')) {
                  _context.next = 18;
                  break;
                }

                controllerId = controller.id;
                _context.next = 23;
                break;

              case 18:
                if (!(typeof controller !== 'string')) {
                  _context.next = 22;
                  break;
                }

                throw new TypeError('"controller" must be a string representing a URL.');

              case 22:
                controllerId = controller;

              case 23:
                _context.next = 35;
                break;

              case 25:
                if (!owner) {
                  _context.next = 35;
                  break;
                }

                if (!(typeof owner === 'object')) {
                  _context.next = 30;
                  break;
                }

                controllerId = owner.id;
                _context.next = 35;
                break;

              case 30:
                if (!(typeof owner !== 'string')) {
                  _context.next = 34;
                  break;
                }

                throw new TypeError('"owner" must be a string representing a URL.');

              case 34:
                controllerId = owner;

              case 35:
                _context.next = 37;
                return jsonld.frame(controllerId, _defineProperty({
                  '@context': constants.SECURITY_CONTEXT_URL,
                  id: controllerId
                }, this.term, {
                  '@embed': '@never',
                  id: verificationId
                }), {
                  documentLoader: documentLoader,
                  compactToRelative: false
                });

              case 37:
                _yield$jsonld$frame = _context.sent;
                _yield$jsonld$frame$ = _slicedToArray(_yield$jsonld$frame['@graph'], 1);
                _yield$jsonld$frame$$ = _yield$jsonld$frame$[0];
                framed = _yield$jsonld$frame$$ === void 0 ? {} : _yield$jsonld$frame$$;
                result.controller = framed;

              case 42:
                verificationMethods = jsonld.getValues(result.controller, this.term);
                result.valid = verificationMethods.some(function (vm) {
                  return vm === verificationId || typeof vm === 'object' && vm.id === verificationId;
                });

                if (result.valid) {
                  _context.next = 46;
                  break;
                }

                throw new Error("Verification method \"".concat(verificationMethod.id, "\" not authorized ") + "by controller for proof purpose \"".concat(this.term, "\"."));

              case 46:
                return _context.abrupt("return", result);

              case 49:
                _context.prev = 49;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", {
                  valid: false,
                  error: _context.t0
                });

              case 52:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 49]]);
      }));

      function validate(_x, _x2) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }]);

  return ControllerProofPurpose;
}(ProofPurpose);